
import { Users } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

interface ClientStatsCardProps {
  clientCount: number;
}

export default function ClientStatsCard({ clientCount }: ClientStatsCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Users className="h-5 w-5 text-blue-500" />
          Total Clients
        </CardTitle>
        <CardDescription>
          {clientCount} active clients
        </CardDescription>
      </CardHeader>
    </Card>
  );
}
